export default function setupGameConfig(variantId) {
  const config = {
    // add your game config options here, these can be the default values
    subtitle: null,
    title: '',
    gameType: '',
    units: '',
    levels: null,
    hundredsFill: true,
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
    case 'count-write-ones-a': // Pre-K
    case 'count-write-ones-b': // Kindergarten
      config.subtitle = 'Counting Fun';
      config.gameType = 'COUNT';
      config.title = 'count_snakes';
      config.units = 1;
      break;
    case 'count-write-tens-a': // Kindergarten
    case 'count-write-tens-b': // 1st Grade
    case 'count-write-tens-c': // 2nd Grade
      config.subtitle = 'Fun with Ones and Tens';
      config.gameType = 'COUNT';
      config.title = 'count_snakes';
      config.units = 10;
      break;
    case 'count-write-hundreds-a': // 2nd Grade
    case 'count-write-hundreds-b': // 3rd Grade
      config.subtitle = 'Fun with Ones, Tens,\nand Hundreds';
      config.gameType = 'COUNT';
      config.title = 'count_snakes';
      config.units = 100;
      break;
    case 'read-make-tens-a': // kindergarten
    case 'read-make-tens-b': // 1st grade
      config.subtitle = 'Fun with Ones and Tens';
      config.title = 'make_snakes'
      config.gameType = 'READ';
      config.units = 10;
      config.hundredsFill = false;
      break;
    case 'read-make-tens-c': // 2nd grade
      config.subtitle = 'Fun with Ones and Tens';
      config.title = 'make_snakes'
      config.gameType = 'READ';
      config.units = 10;
      break;
    case 'read-make-hundreds-a': // 2nd grade
    case 'read-make-hundreds-b': // 3rd grade
      config.subtitle = 'Fun with Ones, Tens,\nand Hundreds';
      config.title = 'make_snakes'
      config.gameType = 'READ';
      config.units = 100;
      break;
    default:
      break;
  }
  return config;
}